
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token-town/slugPages/weeklyDraw",
      function () {
        return require("private-next-pages/token-town/slugPages/weeklyDraw.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token-town/slugPages/weeklyDraw"])
      });
    }
  